module.exports = __webpack_public_path__ + "img/liang_nav.23306210.png";